<template>
  <BaseModal ref="BaseModal" @confirm="confirm" @close="close">
    <div v-if="options.type" class="modal-input">
      <el-checkbox v-if="options.type === 'checkbox'" v-model="input" />
      <el-date-picker
        v-else-if="options.type === 'date'"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择日期"
        v-model="input"
      />
      <el-input-number
        v-else-if="options.type === 'number'"
        :precision="options.scale === undefined ? 2 : options.scale"
        placeholder="请输入"
        :controls="false"
        v-model="input"
        style="width: 100%; text-align: left"
      />
      <el-input v-else placeholder="请输入" v-model="input" />
    </div>

    <div class="vtable" v-if="options.columns">
      <SimpleTable
        :showIndex="options.showIndex || false"
        :allowMultiSelect="options.allowMultiSelect || false"
        ref="simpleTableRef"
        :columns="options.columns || []"
        :data="tableData"
        :menus="options.menus || ['查询']"
        @row-select="handleRowSelect"
        @modify-data-change="options.onModifyDataChangeTop || null"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'

export default {
  name: 'SelectModal',
  components: { BaseModal, SimpleTable },
  data() {
    return {
      options: {},
      tableData: [],
      input: null
    }
  },
  methods: {
    // 显示弹窗
    async show(options = {}) {
      this.options = { ...options }
      this.$refs.BaseModal.show(
        JSON.parse(
          JSON.stringify({
            showConfirm: !!this.options.confirm,
            title: this.options.title,
            width: options.width
          })
        )
      )
      if (this.options.options) {
        this.tableData = JSON.parse(JSON.stringify(this.options.options))
      }
    },
    handleRowSelect(rows) {
      this.input = rows[0][0].dataValue
    },
    async confirm(close) {
      let res
      if (this.options.type) {
        res = this.input
      } else if (this.options.columns) {
        res = this.$refs.simpleTableRef.vtable.getSelectedCellInfos()
      }
      await this.options.confirm(res, this.tableData)
      close()
    },
    close() {}
  }
}
</script>

<style scoped lang="less">
.vtable {
  width: 100%;
  height: 300px;
}
.modal-input {
  margin-bottom: 12px;
}
::v-deep .el-input-number input {
  text-align: left;
}
</style>
